/* eslint-disable */
import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import theme, { fpsColors, fontVars } from './Styles/AppTheme';

const AppTheme = createMuiTheme(theme);

const FPSThemeWrapper = ({ children }) => {
    return (
        <MuiThemeProvider theme={{...AppTheme, ...fpsColors, ...fontVars}}>
            <div className="mgpWrapper">
                {children}
            </div>
        </MuiThemeProvider>
    );
}

export default FPSThemeWrapper;
